module.exports = __webpack_public_path__ + "static/img/bk-banner.fd570e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solutions/airport/bk-banner.png
// module id = jal/
// module chunks = 18